import { useDebounce } from '@/hooks/useDebounce';
import { AuthenticatedHttp } from '@/http/axios';
import { useQuery } from '@tanstack/react-query';
import { useNotify } from '@/components/snackbar';
import { useEffect, useState } from 'react';

export function useApiKeys(searchTerm = '') {
    const notify = useNotify();
    const [pagination, setPagination] = useState({
        page: 1,
        rowsPerPage: 10,
    });

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    useEffect(() => {
        setPagination(prev => ({ ...prev, page: 1 }));
    }, [debouncedSearchTerm]);

    const getKeys = async (page, search) => {
        const hasSearch = search ? `&search=${search}` : '';

        try {
            const { data } = await AuthenticatedHttp.get(`/public_api/api_key/?page=${page}${hasSearch}`);
            return data;
        } catch (error) {
            notify.error('Algo deu errado ao buscar chaves de API!');
            return { results: [], count: 0 };
        }
    };

    const { data: apiKeys, isLoading } = useQuery({
        queryKey: ['api-keys', pagination.page, debouncedSearchTerm],
        queryFn: () => getKeys(pagination.page, debouncedSearchTerm),
    });

    const handleChangePage = (_, newPage) => {
        setPagination((prev) => ({
            ...prev,
            page: newPage,
        }));
    };

    const decrementPage = () => {
        setPagination((prev) => ({
            ...prev,
            page: Math.max(1, prev.page - 1),
        }));
    };

    const results = apiKeys?.results || [];
    const count = apiKeys?.count || 0;

    return {
        results,
        count,
        isLoading,
        pagination,
        handleChangePage,
        decrementPage,
    };
}
